import React from 'react';
import PropTypes from 'prop-types';

import styles from './HardwareButton.scss';

const HardwareButton = ({
  position,
  onClick
}) => (
  <button
    onClick={onClick}
    className={`${styles.HardwareButton} ${styles[position]}`}
  />
);

HardwareButton.defaultProps = {
  onClick: null
};

HardwareButton.propTypes = {
  position: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

export default HardwareButton;



// WEBPACK FOOTER //
// ./src/components/buttons/HardwareButton/HardwareButton.js